<ng-container *ngIf="userLoggedIn">
    <div class="content" [ngClass]="status ? 'sidebar-close' : 'sidebar-open'">
        <a class="arrowToggle btn" (click)="clickEvent()" rel="noreferrer">
            <em class="fas " [ngClass]="status ? 'fa-arrow-right' : 'fa-bars'"></em>
        </a>
        <app-header></app-header>
        <div class="rightside">
            <div class="layout-section">
                <div class="mb-auto">
                    <router-outlet></router-outlet>
                </div>
                <footer class="footer mt-auto">
                    <div class="container">
                        <div class="row flmid">
                            <div class="col">
                                <p class="copyright clearfix m-0">
                                    &copy;&nbsp;{{currentYear}}&nbsp;<span translate>lblCopyRight</span> <a href="https://www.autofacets.com/" target="_blank" rel="noopener"> AutoFacets</a>, <span translate>lblAllRightReserved</span>
                                </p>
                            </div>
                            <div class="col-auto ml-auto powered-text">
                                <div class="flmid">
                                    <span translate>lblPoweredBy</span> 
                                    <img class="brand" src="../assets/images/afx/header-logo.svg" style="width:125px" alt="Logo" />
                                </div>

                            </div>
                        </div>
                    </div>
                </footer>
            </div>

        </div>

    </div>
    <ngx-spinner size="medium" bdColor="rgba(0,0,0,0.3)" color="#414042" type="ball-clip-rotate">
    </ngx-spinner>
</ng-container>